var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-form",
        {
          ref: "ruleForm1",
          staticClass: "demo-ruleForm",
          staticStyle: { width: "60%", "margin-top": "20px" },
          attrs: {
            model: _vm.ruleForm,
            rules: _vm.rules,
            "label-width": "150px",
          },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "安卓  AppKey", prop: "androidAppKey" } },
            [
              _c("el-input", {
                attrs: { placeholder: "" },
                model: {
                  value: _vm.ruleForm.androidAppKey,
                  callback: function ($$v) {
                    _vm.$set(_vm.ruleForm, "androidAppKey", $$v)
                  },
                  expression: "ruleForm.androidAppKey",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "ios  AppKey", prop: "iosAppKey" } },
            [
              _c("el-input", {
                attrs: { placeholder: "" },
                model: {
                  value: _vm.ruleForm.iosAppKey,
                  callback: function ($$v) {
                    _vm.$set(_vm.ruleForm, "iosAppKey", $$v)
                  },
                  expression: "ruleForm.iosAppKey",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "Master Secret", prop: "masterSecret" } },
            [
              _c("el-input", {
                attrs: { placeholder: "" },
                model: {
                  value: _vm.ruleForm.masterSecret,
                  callback: function ($$v) {
                    _vm.$set(_vm.ruleForm, "masterSecret", $$v)
                  },
                  expression: "ruleForm.masterSecret",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "安卓推送" } },
            [
              _c(
                "el-radio-group",
                {
                  model: {
                    value: _vm.ruleForm.androidPushStatus,
                    callback: function ($$v) {
                      _vm.$set(_vm.ruleForm, "androidPushStatus", $$v)
                    },
                    expression: "ruleForm.androidPushStatus",
                  },
                },
                [
                  _c("el-radio", { attrs: { label: 1 } }, [_vm._v("开启")]),
                  _vm._v(" "),
                  _c("el-radio", { attrs: { label: 0 } }, [_vm._v("关闭")]),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "ios推送" } },
            [
              _c(
                "el-radio-group",
                {
                  model: {
                    value: _vm.ruleForm.iosPushStatus,
                    callback: function ($$v) {
                      _vm.$set(_vm.ruleForm, "iosPushStatus", $$v)
                    },
                    expression: "ruleForm.iosPushStatus",
                  },
                },
                [
                  _c("el-radio", { attrs: { label: 1 } }, [_vm._v("开启")]),
                  _vm._v(" "),
                  _c("el-radio", { attrs: { label: 0 } }, [_vm._v("关闭")]),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { staticStyle: { "margin-top": "20px" } },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.submitForm("ruleForm1")
                    },
                  },
                },
                [_vm._v("保存")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }